<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import {ModelListSelect} from "vue-search-select";
import {mapActions, mapGetters, mapState} from "vuex";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Bill of Materials",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader, ModelListSelect, Loader},
  data() {
    return {
      title: "Bill of Materials",
      items: [
        {text: "Home", href: "/"},
        {text: "Bill of Materials", active: true},
      ],
      selected: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      filterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {key: "index", label: "S/N", sortable: false},
        {key: "product", sortable: true, label: "PRODUCT"},
        {key: "product_qty", label: "PRODUCT QTY", sortable: false},
        {key: "bill_of_materials", label: "BILL OF MATERIALS"},
      ],
      ingredientFields: [
        {key: "recipe", label: "INPUT ITEM"},
        {key: "recipe_qty", label: "INPUT QUANTITY"},
        {key: "unit_cost", label: "UNIT COST"},
        {key: "total_cost", label: "TOTAL COST"},
        {key: "actions", label: "ACTIONS"},
      ],
      filterdata: {
        product: "",
      },
      editdata: {
        id: "",
        recipe: "",
        product: "",
        product_qty: "",
        recipe_qty: "",
      },
      editProductData: {
        product_id: null,
        product_qty: null,
        productunit: null,
      },
      deletedata: {
        recipe: "",
        product: "",
        id: "",
      },
      basedata: {
        recipe: "",
        product: "",
        product_id: "",
        id: "",
      },
      recipeQtyError: "",
      productQtyError: "",
      editProductQtyError: "",
    };
  },
  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("recipes", ["SaveStatus", "Recipes"]),
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("products", ["Products"]),

    rows() {
      return this.groupedProductsArray.length;
    },

    groupedIngredientsByProduct() {
      if (!this.Recipes) return [];

      const grouped = {};
      this.Recipes.forEach((recipe) => {
        const productName = recipe.product;
        if (!grouped[productName]) {
          grouped[productName] = {
            product: productName,
            product_id: recipe.product_id,
            product_qty: recipe.product_qty,
            productunit: recipe.productunit,
            items: [],
          };
        }
        grouped[productName].items.push({
          ...recipe,
        });
      });
      return Object.values(grouped);
    },

    groupedProductsArray() {
      return this.groupedIngredientsByProduct.map((product, index) => ({
        ...product,
        index: index + 1,
      }));
    },

    excelData() {
      const data = [];
      this.groupedIngredientsByProduct.forEach(productGroup => {
        // Add a row for the product header
        data.push({
          product: productGroup.product,
          product_qty: productGroup.product_qty + ' ' + productGroup.productunit,
          ingredient: '', // Empty for header row
          recipe_qty: '',
          unit_cost: '',
          total_cost: ''
        });

        // Add rows for each ingredient
        productGroup.items.forEach(item => {
          data.push({
            product: '', // Empty for ingredient rows
            product_qty: '',
            ingredient: item.recipe,
            recipe_qty: item.recipe_qty + ' ' + item.recipeunit,
            unit_cost: item.recipe_details.buying_price,
            total_cost: item.recipe_details.buying_price * item.recipe_qty
          });
        });

        // Add an empty row as a separator
        data.push({});
      });

      return data;
    },

    excelFields() {
      return {
        "Product": "product",
        "Product Qty": "product_qty",
        "Raw Material": "ingredient",
        "Raw Material Qty": "recipe_qty",
        "Unit Cost": "unit_cost",
        "Total Cost": "total_cost",
      };
    },
  },
  mounted() {
    this.totalRows = this.rows;
  },
  watch: {
    show(newValue) {
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    'filterdata.product': {
      handler() {
        this.getIngredients();
      },
      immediate: true,
    },
    Recipes() {
      this.totalRows = this.rows;
    }
  },
  methods: {
    ...mapActions({
      FetchRecipes: "recipes/fetchRecipes",
      FetchItems: "products/fetchProducts",
      DeleteRecipe: "recipes/deleteRecipes",
      EditRecipe: "recipes/editRecipes",
      ChangeBase: "recipes/changeBase",
      EditProductQty: "recipes/editProductQuantity",
    }),

    thousandSeprator(m) {
      if (m !== "" && m !== undefined && m !== null && m !== 0) {
        return m.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return m;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    closeModal(modalId) {
      this.$bvModal.hide(modalId);
      this.resetData();
      this.resetErrors();
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata = {recipe: "", product: "", id: ""};
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata = {id: "", recipe: "", product: "", product_qty: "", recipe_qty: ""};
      this.modal_id = "";
    },
    resetEditProduct(modalId) {
      this.closeModal(modalId);
      this.editProductData = {product_id: null, product_qty: null, productunit: null};
      this.editProductQtyError = "";
      this.modal_id = "";
    },
    resetErrors() {
      this.recipeQtyError = "";
      this.productQtyError = "";
      this.editProductQtyError = "";
    },
    resetBase() {
      this.basedata = {recipe: "", product: "", product_id: "", id: ""};
      this.modal_id = "";
    },
    resetData() {
      // this.filter = null;
    },

    showEditModal(data) {
      this.editdata = {...data};
    },
    showEditProductModal(data) {
      this.editProductData.product_id = data.product_id;
      this.editProductData.product_qty = data.product_qty;
      this.editProductData.productunit = data.productunit;
    },
    showDeleteModal(data) {
      this.deletedata = {...data};
    },
    showBaseModal(data) {
      this.basedata = {...data};
    },

    editItem(modalId) {
      this.modal_id = modalId;
      if (!this.isValidQuantity(this.editdata.recipe_qty)) {
        this.recipeQtyError = "Ingredient Quantity must be a valid number.";
        return;
      }
      this.recipeQtyError = "";

      if (!this.isValidQuantity(this.editdata.product_qty)) {
        this.productQtyError = "Product Quantity must be a valid number.";
        return;
      }
      this.productQtyError = "";

      this.EditRecipe(this.editdata);
    },
    editProductQuantity(modalId) {
      this.modal_id = modalId;
      if (!this.isValidQuantity(this.editProductData.product_qty)) {
        this.editProductQtyError = "Product Quantity must be a valid number.";
        return;
      }
      this.editProductQtyError = "";

      this.EditProductQty(this.editProductData);
    },

    isValidQuantity(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteRecipe(this.deletedata);
    },

    changeBase(modalId) {
      this.modal_id = modalId;
      this.basedata.product_id = parseInt(this.basedata.product_id);
      this.ChangeBase(this.basedata);
    },

    getIngredients() {
      this.FetchRecipes(this.filterdata);
    },
  },
  created() {
    this.FetchItems();
    this.getIngredients();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-7"></div>
              <div class="col-md-5 text end">
                <div class="d-flex align-items-center">
                  <download-excel
                      class="btn btn-primary me-2"
                      :data="excelData"
                      :worksheet="'Ingredients'"
                      type="xls"
                      :name="'Ingredients.xls'"
                  >
                    Export <i class="fa fa-file-excel"></i>
                  </download-excel>
                  <div class="mb-4 flex-grow-1">
                    <label>Filter by Product</label>
                    <model-list-select
                        :list="[...(Products || []), { id: '', name: 'All Products' }]"
                        v-model="filterdata.product"
                        option-value="id"
                        option-text="name"
                        placeholder="Select Product"
                    >
                    </model-list-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:&nbsp;
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search product..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables main-table"
                  :items="groupedProductsArray"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <!-- Index Column -->
                <template #cell(index)="data">
                  {{ data.item.index }}
                </template>

                <template #cell(product)="data">
                  {{ data.item.product }}
                </template>

                <!-- Product Quantity Column -->
                <template #cell(product_qty)="data">
                  {{ data.item.product_qty }} {{ data.item.productunit }}
                  <b-button
                      v-if="MyUserPerm.edit_ingredients"
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-product-qty-modal
                      class="ml-1"
                      @click="showEditProductModal(data.item)"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                </template>

                <!-- Ingredients Column (Nested Table) -->
                <template #cell(bill_of_materials)="data">
                  <b-table
                      :items="data.item.items"
                      :fields="ingredientFields"
                      responsive="sm"
                      class="mb-0 inner-table"
                      :tbody-tr-class="'inner-table-row'"
                  >
                    <template #cell(recipe_qty)="innerData">
                      {{ innerData.item ? innerData.item.recipe_qty : 0 }}
                      {{ innerData.item.recipeunit }}
                    </template>

                    <template #cell(unit_cost)="innerData">
                      {{
                        innerData.item && innerData.item.recipe_details ? thousandSeprator(innerData.item.recipe_details.buying_price) : 0
                      }}
                    </template>
                    <template #cell(total_cost)="innerData">
                      {{
                        innerData.item && innerData.item.recipe_details ? thousandSeprator(innerData.item.recipe_details.buying_price * innerData.item.recipe_qty) : 0
                      }}
                    </template>

                    <template #cell(actions)="innerData">
                      <b-button-group>
                        <b-button
                            v-if="MyUserPerm.edit_ingredients"
                            size="sm"
                            variant="primary"
                            v-b-modal.edit-item-modal
                            @click="showEditModal(innerData.item)"
                        >
                          <i class="fa fa-edit"></i>
                        </b-button>
                        <b-button
                            v-if="!innerData.item.is_base && MyUserPerm.delete_ingredients"
                            v-b-modal.delete-item-modal
                            variant="danger"
                            size="sm"
                            @click="showDeleteModal(innerData.item)"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                        <b-button
                            size="sm"
                            v-if="!innerData.item.is_base"
                            class="bg-soft"
                            v-b-modal.base-ingredient-modal
                            @click="showBaseModal(innerData.item)"
                        >
                          <i class="fa fa-cog"></i> Set as Base
                        </b-button>
                      </b-button-group>
                    </template>
                  </b-table>
                </template>
              </b-table>

              <!-- modal change default ingredient starts -->
              <b-modal
                  header-bg-variant="warning"
                  header-text-variant="light"
                  body-text-variant="warning"
                  footer-bg-variant="warning"
                  footer-text-variant="warning"
                  id="base-ingredient-modal"
                  hide-footer
                  @hidden="resetBase()"
              >
                <template #modal-title>
                  Set Item <small><em>{{ basedata.recipe }}</em></small> as Base Raw Material
                </template>
                <div class="form-group mb-2">
                  <div class="input-group">
                    <h5>
                      Do you want to set Item
                      <small class="text-warning"><em>{{ basedata.recipe }}</em></small> as Base Raw Material
                      for Product <small class="text-warning"><em>{{ basedata.product }}</em></small>?
                      <br/>
                      This means this item will be considered the default raw material for this product in
                      bill of materials. Click Proceed Button to continue.
                    </h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      @click="closeModal('base-ingredient-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-primary" @click="changeBase('base-ingredient-modal')">
                    <i class="fa fa-cog"></i> Proceed
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Changing"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- modal edit item starts -->
              <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()" class="text-primary">
                <template #modal-title>
                  Edit Raw Material {{ editdata.recipe }} for product {{ editdata.product }}
                </template>
                <div class="form-group mb-3">
                  <label>Raw Material Quantity</label>
                  <input type="number" class="form-control" step="any" v-model="editdata.recipe_qty"/>
                  <div v-if="recipeQtyError" class="text-danger">{{ recipeQtyError }}</div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="closeModal('edit-item-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-primary" @click="editItem('edit-item-modal')">
                    <i class="fa fa-check"></i> Save Changes
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Deleting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- modal edit product quantity starts -->
              <b-modal id="edit-product-qty-modal" hide-footer @hidden="resetEditProduct" class="text-primary">
                <template #modal-title>
                  Edit Product Quantity
                </template>
                <div class="form-group mb-3">
                  <label>Product Quantity</label>
                  <input
                      type="number"
                      class="form-control"
                      step="any"
                      v-model="editProductData.product_qty"
                  />
                  <div v-if="editProductQtyError" class="text-danger">{{ editProductQtyError }}</div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="closeModal('edit-product-qty-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="editProductQuantity('edit-product-qty-modal')"
                  >
                    <i class="fa fa-check"></i> Save Changes
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Updating"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <!-- modal delete item starts -->
              <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem" class="text-danger">
                <template #modal-title>
                  Delete Raw Material {{ deletedata.recipe }} for product {{ deletedata.product }}
                </template>
                <div class="form-group mb-3">
                  <div class="input-group">
                    <h5>Do you want to delete this Raw Material? Click Proceed to continue.</h5>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      @click="closeModal('delete-item-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button type="button" class="btn btn-danger" @click="deleteItem('delete-item-modal')">
                    <i class="fa fa-trash"></i> Proceed
                    <b-spinner
                        v-if="SaveStatus"
                        variant="light"
                        small
                        label="Deleting"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
              <!-- modal ends -->

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!Recipes"/>
          </div>
        </div>
      </div>
    </div>
    <!--  end row -->
  </Layout>
</template>

<style scoped>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}

/* Main table styles */
.main-table {
  width: 100%;
}

.main-table th,
.main-table td {
  vertical-align: top;
  padding: 0.75rem;
}

/* Inner table styles */
.inner-table {
  width: 100%;
  margin-bottom: 0 !important;
  border: none !important;
}

.inner-table th,
.inner-table td {
  padding: 0.5rem !important;
  border-top: none !important;
  vertical-align: middle;
}

.inner-table thead th {
  border-bottom: 1px solid #dee2e6 !important;
}

/* Style for rows in the inner table */
.inner-table-row {
  border-bottom: 1px solid #dee2e6;
}

.inner-table-row:last-child {
  border-bottom: none;
}

.ml-1 {
  margin-left: 0.5rem;
}
</style>